export const ERROR_MESSAGES: Record<string, string> = {
  VALIDATION_ERROR: 'Please check your inputs and try again.',
  EMAIL_EXISTS: 'An account with this email already exists.',
  UNAUTHORIZED: 'Your session has expired. Please sign in again.',
  RATE_LIMIT_EXCEEDED: 'Too many attempts. Please try again in a minute.',
  INTERNAL_ERROR: 'An unexpected error occurred. Please try again later.',
  OFFLINE: 'Network error. Please check your internet connection.',
  UNKNOWN: 'Something went wrong, please try again.',
  EVENT_NOT_LIVE: 'This action requires the event to be live.'
};

export function getErrorMessage(code?: string): string {
  if (!code) {
    return ERROR_MESSAGES.UNKNOWN;
  }
  return ERROR_MESSAGES[code] || ERROR_MESSAGES.UNKNOWN;
}
